/**
 * Contacts Module Configuration
 *
 * Manages people associated with properties and tenants.
 * Supports full CRUD, bulk actions, CSV export, Apollo sync,
 * and cross-linked contact panels on Property/Tenant detail views.
 *
 * @see .context/WEB-APP.md for architecture documentation
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const contactsModule: AppModule = {
    id: 'contacts',

    navigation: {
        label: 'Contacts',
        icon: 'book-user',
        path: '/contacts',
        order: 20,
        moduleKey: 'contacts',


        pages: [
            {
                label: 'All Contacts',
                path: '/contacts',
            },
            {
                label: 'Add Contact',
                path: '/contacts/create',
                icon: 'user-plus',
            },
        ],
    },

    routes,
}

export default contactsModule
